

























import { Component, Model, Prop, Vue } from 'vue-property-decorator';

@Component({
    components: {}
})
export default class CFormSelect extends Vue {
    @Prop()
    name!: string;

    @Prop({
        type: Array,
        default: () => []
    })
    options!: {
        label: string | number;
        value: string | number;
    };

    @Prop({
        default: 'text'
    })
    type!: string;

    @Prop({
        default: ''
    })
    variant!: string;

    @Prop({
        default: ''
    })
    placeholder!: string;

    @Prop({
        default: false
    })
    disabled!: boolean;

    @Model('input', { type: [String, Number] })
    readonly value!: string;

    inputValue(e: any) {
        if (e && e.target && e.target.value) {
            this.$emit('input', e.target.value);
        }
    }
}
